import { Nillable } from '@web/utils';
import { TableFilter, TableSort } from '@web/common';

export class TableLazyLoad<Filter = never> {
  public constructor(
    public readonly first: number,
    public readonly rows: number,
    public readonly sort?: Nillable<TableSort>,
    public readonly filter?: Nillable<TableFilter<Filter>>,
  ) {}

  public get page(): number {
    return Math.floor(this.first / this.rows) + 1;
  }
}
